var _classCallCheck = require("D:\\pure360-web-booking-v2\\src\\web_pc\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\pure360-web-booking-v2\\src\\web_pc\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var t = {
    60: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, {
        default: function _default() {
          return c;
        },
        useAsyncStorage: function useAsyncStorage() {
          return a;
        }
      });

      var n = r(942).bind({
        concatArrays: !0,
        ignoreUndefined: !0
      }),
          o = function o(t, e) {
        return new Promise(function (r, n) {
          try {
            var _n = t();

            e && e(null, _n), r(_n);
          } catch (t) {
            e && e(t), n(t);
          }
        });
      },
          i = function i(t, e, r) {
        return Promise.all(t).then(function (t) {
          var n = r ? r(t) : null;
          return e && e(null, n), Promise.resolve(n);
        }, function (t) {
          return e && e(t), Promise.reject(t);
        });
      };

      var s = /*#__PURE__*/function () {
        function s() {
          _classCallCheck(this, s);
        }

        _createClass(s, null, [{
          key: "getItem",
          value: function getItem(t, e) {
            return o(function () {
              return window.localStorage.getItem(t);
            }, e);
          }
        }, {
          key: "setItem",
          value: function setItem(t, e, r) {
            return o(function () {
              window.localStorage.setItem(t, e);
            }, r);
          }
        }, {
          key: "removeItem",
          value: function removeItem(t, e) {
            return o(function () {
              return window.localStorage.removeItem(t);
            }, e);
          }
        }, {
          key: "mergeItem",
          value: function mergeItem(t, e, r) {
            return o(function () {
              (function (t, e) {
                var r = window.localStorage.getItem(t),
                    o = JSON.parse(r),
                    i = JSON.parse(e),
                    s = JSON.stringify(n(o, i));
                window.localStorage.setItem(t, s);
              })(t, e);
            }, r);
          }
        }, {
          key: "clear",
          value: function clear(t) {
            return o(function () {
              window.localStorage.clear();
            }, t);
          }
        }, {
          key: "getAllKeys",
          value: function getAllKeys(t) {
            return o(function () {
              var t = window.localStorage.length,
                  e = [];

              for (var _r = 0; _r < t; _r += 1) {
                var _t = window.localStorage.key(_r);

                e.push(_t);
              }

              return e;
            }, t);
          }
        }, {
          key: "flushGetRequests",
          value: function flushGetRequests() {}
        }, {
          key: "multiGet",
          value: function multiGet(t, e) {
            var r = t.map(function (t) {
              return s.getItem(t);
            });
            return i(r, e, function (e) {
              return e.map(function (e, r) {
                return [t[r], e];
              });
            });
          }
        }, {
          key: "multiSet",
          value: function multiSet(t, e) {
            var r = t.map(function (t) {
              return s.setItem(t[0], t[1]);
            });
            return i(r, e);
          }
        }, {
          key: "multiRemove",
          value: function multiRemove(t, e) {
            var r = t.map(function (t) {
              return s.removeItem(t);
            });
            return i(r, e);
          }
        }, {
          key: "multiMerge",
          value: function multiMerge(t, e) {
            var r = t.map(function (t) {
              return s.mergeItem(t[0], t[1]);
            });
            return i(r, e);
          }
        }]);

        return s;
      }();

      function a(t) {
        return {
          getItem: function getItem() {
            for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
              e[_key] = arguments[_key];
            }

            return s.getItem.apply(s, [t].concat(e));
          },
          setItem: function setItem() {
            for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              e[_key2] = arguments[_key2];
            }

            return s.setItem.apply(s, [t].concat(e));
          },
          mergeItem: function mergeItem() {
            for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              e[_key3] = arguments[_key3];
            }

            return s.mergeItem.apply(s, [t].concat(e));
          },
          removeItem: function removeItem() {
            for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              e[_key4] = arguments[_key4];
            }

            return s.removeItem.apply(s, [t].concat(e));
          }
        };
      }

      var c = s;
    },
    310: function _(t) {
      "use strict";

      t.exports = function (t) {
        if ("[object Object]" !== Object.prototype.toString.call(t)) return !1;
        var e = Object.getPrototypeOf(t);
        return null === e || e === Object.prototype;
      };
    },
    942: function _(t, e, r) {
      "use strict";

      var n = r(310),
          o = Object.prototype.hasOwnProperty,
          i = Object.propertyIsEnumerable,
          s = function s(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          writable: !0,
          enumerable: !0,
          configurable: !0
        });
      },
          a = this,
          c = {
        concatArrays: !1,
        ignoreUndefined: !1
      },
          u = function u(t) {
        var e = [];

        for (var _r2 in t) {
          o.call(t, _r2) && e.push(_r2);
        }

        if (Object.getOwnPropertySymbols) {
          var _r3 = Object.getOwnPropertySymbols(t);

          var _iterator = _createForOfIteratorHelper(_r3),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _n2 = _step.value;
              i.call(t, _n2) && e.push(_n2);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return e;
      };

      function l(t) {
        return Array.isArray(t) ? function (t) {
          var e = t.slice(0, 0);
          return u(t).forEach(function (r) {
            s(e, r, l(t[r]));
          }), e;
        }(t) : n(t) ? function (t) {
          var e = null === Object.getPrototypeOf(t) ? Object.create(null) : {};
          return u(t).forEach(function (r) {
            s(e, r, l(t[r]));
          }), e;
        }(t) : t;
      }

      var f = function f(t, e, r, n) {
        return r.forEach(function (r) {
          void 0 === e[r] && n.ignoreUndefined || (r in t && t[r] !== Object.getPrototypeOf(t) ? s(t, r, h(t[r], e[r], n)) : s(t, r, l(e[r])));
        }), t;
      };

      function h(t, e, r) {
        return r.concatArrays && Array.isArray(t) && Array.isArray(e) ? function (t, e, r) {
          var n = t.slice(0, 0),
              i = 0;
          return [t, e].forEach(function (e) {
            var a = [];

            for (var _r4 = 0; _r4 < e.length; _r4++) {
              o.call(e, _r4) && (a.push(String(_r4)), s(n, i++, e === t ? e[_r4] : l(e[_r4])));
            }

            n = f(n, e, u(e).filter(function (t) {
              return !a.includes(t);
            }), r);
          }), n;
        }(t, e, r) : n(e) && n(t) ? f(t, e, u(e), r) : l(e);
      }

      t.exports = function () {
        var e = h(l(c), this !== a && this || {}, c);
        var r = {
          _: {}
        };

        for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          t[_key5] = arguments[_key5];
        }

        for (var _i = 0, _t2 = t; _i < _t2.length; _i++) {
          var _o = _t2[_i];

          if (void 0 !== _o) {
            if (!n(_o)) throw new TypeError("`" + _o + "` is not an Option Object");
            r = h(r, {
              _: _o
            }, e);
          }
        }

        return r._;
      };
    },
    279: function _(t) {
      function e() {}

      e.prototype = {
        on: function on(t, e, r) {
          var n = this.e || (this.e = {});
          return (n[t] || (n[t] = [])).push({
            fn: e,
            ctx: r
          }), this;
        },
        once: function once(t, e, r) {
          var n = this;

          function o() {
            n.off(t, o), e.apply(r, arguments);
          }

          return o._ = e, this.on(t, o, r);
        },
        emit: function emit(t) {
          for (var e = [].slice.call(arguments, 1), r = ((this.e || (this.e = {}))[t] || []).slice(), n = 0, o = r.length; n < o; n++) {
            r[n].fn.apply(r[n].ctx, e);
          }

          return this;
        },
        off: function off(t, e) {
          var r = this.e || (this.e = {}),
              n = r[t],
              o = [];
          if (n && e) for (var i = 0, s = n.length; i < s; i++) {
            n[i].fn !== e && n[i].fn._ !== e && o.push(n[i]);
          }
          return o.length ? r[t] = o : delete r[t], this;
        }
      }, t.exports = e, t.exports.TinyEmitter = e;
    },
    9: function _(t, e, r) {
      "use strict";

      var _n3,
          o = this && this.__extends || (_n3 = function n(t, e) {
        return _n3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        }, _n3(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          i = this && this.__assign || function () {
        return i = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var o in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }, i.apply(this, arguments);
      },
          s = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(t) {
            try {
              c(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              c(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(s, a);
          }

          c((n = n.apply(t, e || [])).next());
        });
      },
          a = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      },
          c = this && this.__spreadArray || function (t, e, r) {
        if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) {
          !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
        }
        return t.concat(n || Array.prototype.slice.call(e));
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.InMemoryStorageProvider = e.LocalStorageProvider = e.UnleashClient = e.EVENTS = void 0;
      var u = r(279),
          l = r(524),
          f = r(432);
      e.LocalStorageProvider = f.default;
      var h = r(475);
      e.InMemoryStorageProvider = h.default;
      var p = ["userId", "sessionId", "remoteAddress"];
      e.EVENTS = {
        INIT: "initialized",
        ERROR: "error",
        READY: "ready",
        UPDATE: "update"
      };

      var d = {
        name: "disabled"
      },
          y = "repo",
          v = function v() {
        try {
          if ("fetch" in window) return fetch.bind(window);
          if ("fetch" in globalThis) return fetch.bind(globalThis);
        } catch (t) {
          console.error('Unleash failed to resolve "fetch"', t);
        }
      },
          g = function (t) {
        function r(r) {
          var n = r.storageProvider,
              o = r.url,
              c = r.clientKey,
              u = r.disableRefresh,
              h = void 0 !== u && u,
              p = r.refreshInterval,
              d = void 0 === p ? 30 : p,
              y = r.metricsInterval,
              g = void 0 === y ? 30 : y,
              b = r.disableMetrics,
              m = void 0 !== b && b,
              w = r.appName,
              x = r.environment,
              S = void 0 === x ? "default" : x,
              E = r.context,
              I = r.fetch,
              O = void 0 === I ? v() : I,
              _ = r.bootstrap,
              P = r.bootstrapOverride,
              T = void 0 === P || P,
              k = t.call(this) || this;
          if (k.toggles = [], k.etag = "", !o) throw new Error("url is required");
          if (!c) throw new Error("clientKey is required");
          if (!w) throw new Error("appName is required.");
          return k.toggles = _ && _.length > 0 ? _ : [], k.url = new URL("" + o), k.clientKey = c, k.storage = n || new f.default(), k.refreshInterval = h ? 0 : 1e3 * d, k.context = i({
            appName: w,
            environment: S
          }, E), k.ready = new Promise(function (t) {
            return s(k, void 0, void 0, function () {
              var r;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return n.trys.push([0, 2,, 3]), [4, this.init()];

                  case 1:
                    return n.sent(), [3, 3];

                  case 2:
                    return r = n.sent(), console.error(r), this.emit(e.EVENTS.ERROR, r), [3, 3];

                  case 3:
                    return t(), [2];
                }
              });
            });
          }), O || console.error('Unleash: You must either provide your own "fetch" implementation or run in an environment where "fetch" is available.'), k.fetch = O, k.bootstrap = _ && _.length > 0 ? _ : void 0, k.bootstrapOverride = T, k.metrics = new l.default({
            appName: w,
            metricsInterval: g,
            disableMetrics: m,
            url: o,
            clientKey: c,
            fetch: O
          }), k;
        }

        return o(r, t), r.prototype.getAllToggles = function () {
          return c([], this.toggles, !0);
        }, r.prototype.isEnabled = function (t) {
          var e = this.toggles.find(function (e) {
            return e.name === t;
          }),
              r = !!e && e.enabled;
          return this.metrics.count(t, r), r;
        }, r.prototype.getVariant = function (t) {
          var e = this.toggles.find(function (e) {
            return e.name === t;
          });
          return e ? (this.metrics.count(t, !0), e.variant) : (this.metrics.count(t, !1), d);
        }, r.prototype.updateContext = function (t) {
          return s(this, void 0, void 0, function () {
            var e;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return (t.appName || t.environment) && console.warn("appName and environment are static. They can't be updated with updateContext."), e = {
                    environment: this.context.environment,
                    appName: this.context.appName
                  }, this.context = i(i({}, e), t), this.timerRef ? [4, this.fetchToggles()] : [3, 2];

                case 1:
                  r.sent(), r.label = 2;

                case 2:
                  return [2];
              }
            });
          });
        }, r.prototype.getContext = function () {
          return i({}, this.context);
        }, r.prototype.setContextField = function (t, e) {
          var r, n;
          if (p.includes(t)) this.context = i(i({}, this.context), ((r = {})[t] = e, r));else {
            var o = i(i({}, this.context.properties), ((n = {})[t] = e, n));
            this.context = i(i({}, this.context), {
              properties: o
            });
          }
          this.timerRef && this.fetchToggles();
        }, r.prototype.init = function () {
          return s(this, void 0, void 0, function () {
            var t, r;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.resolveSessionId()];

                case 1:
                  return t = n.sent(), this.context = i({
                    sessionId: t
                  }, this.context), r = this, [4, this.storage.get(y)];

                case 2:
                  return r.toggles = n.sent() || [], !this.bootstrap || !this.bootstrapOverride && 0 !== this.toggles.length ? [3, 4] : [4, this.storage.save(y, this.bootstrap)];

                case 3:
                  n.sent(), this.toggles = this.bootstrap, n.label = 4;

                case 4:
                  return this.emit(e.EVENTS.INIT), [2];
              }
            });
          });
        }, r.prototype.start = function () {
          return s(this, void 0, void 0, function () {
            var t,
                r = this;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.timerRef ? (console.error("Unleash SDK has already started, if you want to restart the SDK you should call client.stop() before starting again."), [2]) : [4, this.ready];

                case 1:
                  return n.sent(), this.metrics.start(), t = this.refreshInterval, [4, this.fetchToggles()];

                case 2:
                  return n.sent(), this.emit(e.EVENTS.READY), t > 0 && (this.timerRef = setInterval(function () {
                    return r.fetchToggles();
                  }, t)), [2];
              }
            });
          });
        }, r.prototype.stop = function () {
          this.timerRef && (clearInterval(this.timerRef), this.timerRef = void 0), this.metrics.stop();
        }, r.prototype.resolveSessionId = function () {
          return s(this, void 0, void 0, function () {
            var t;
            return a(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.context.sessionId ? [2, this.context.sessionId] : [3, 1];

                case 1:
                  return [4, this.storage.get("sessionId")];

                case 2:
                  return (t = e.sent()) ? [3, 4] : (t = Math.floor(1e9 * Math.random()), [4, this.storage.save("sessionId", t)]);

                case 3:
                  e.sent(), e.label = 4;

                case 4:
                  return [2, t];
              }
            });
          });
        }, r.prototype.storeToggles = function (t) {
          return s(this, void 0, void 0, function () {
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return this.toggles = t, this.emit(e.EVENTS.UPDATE), [4, this.storage.save(y, t)];

                case 1:
                  return r.sent(), [2];
              }
            });
          });
        }, r.prototype.fetchToggles = function () {
          return s(this, void 0, void 0, function () {
            var t, r, n, o, i;
            return a(this, function (s) {
              switch (s.label) {
                case 0:
                  if (!this.fetch) return [3, 7];
                  s.label = 1;

                case 1:
                  return s.trys.push([1, 6,, 7]), t = this.context, r = new URL(this.url.toString()), Object.entries(t).forEach(function (t) {
                    var e = t[0],
                        n = t[1];
                    "properties" === e && n ? Object.entries(n).forEach(function (t) {
                      var e = t[0],
                          n = t[1];
                      return r.searchParams.append("properties[" + e + "]", n);
                    }) : r.searchParams.append(e, n);
                  }), [4, this.fetch(r.toString(), {
                    cache: "no-cache",
                    headers: {
                      Authorization: this.clientKey,
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      "If-None-Match": this.etag
                    }
                  })];

                case 2:
                  return (n = s.sent()).ok && 304 !== n.status ? (this.etag = n.headers.get("ETag") || "", [4, n.json()]) : [3, 5];

                case 3:
                  return o = s.sent(), [4, this.storeToggles(o.toggles)];

                case 4:
                  s.sent(), s.label = 5;

                case 5:
                  return [3, 7];

                case 6:
                  return i = s.sent(), console.error("Unleash: unable to fetch feature toggles", i), this.emit(e.EVENTS.ERROR, i), [3, 7];

                case 7:
                  return [2];
              }
            });
          });
        }, r;
      }(u.TinyEmitter);

      e.UnleashClient = g;
    },
    524: function _(t, e) {
      "use strict";

      var r = this && this.__assign || function () {
        return r = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var o in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }, r.apply(this, arguments);
      },
          n = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(t) {
            try {
              c(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              c(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(s, a);
          }

          c((n = n.apply(t, e || [])).next());
        });
      },
          o = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var i = function () {
        function t(t) {
          var e = t.appName,
              r = t.metricsInterval,
              n = t.disableMetrics,
              o = void 0 !== n && n,
              i = t.url,
              s = t.clientKey,
              a = t.fetch;
          this.disabled = o, this.metricsInterval = 1e3 * r, this.appName = e, this.url = i, this.clientKey = s, this.bucket = this.createEmptyBucket(), this.fetch = a;
        }

        return t.prototype.start = function () {
          var t = this;
          if (this.disabled) return !1;
          "number" == typeof this.metricsInterval && this.metricsInterval > 0 && setTimeout(function () {
            t.startTimer(), t.sendMetrics();
          }, 2e3);
        }, t.prototype.stop = function () {
          this.timer && (clearTimeout(this.timer), delete this.timer);
        }, t.prototype.createEmptyBucket = function () {
          return {
            start: new Date(),
            stop: null,
            toggles: {}
          };
        }, t.prototype.sendMetrics = function () {
          return n(this, void 0, void 0, function () {
            var t, e;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = this.url + "/client/metrics", e = this.getPayload(), this.bucketIsEmpty(e) ? [2] : [4, this.fetch(t, {
                    cache: "no-cache",
                    method: "POST",
                    headers: {
                      Authorization: this.clientKey,
                      Accept: "application/json",
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(e)
                  })];

                case 1:
                  return r.sent(), [2];
              }
            });
          });
        }, t.prototype.count = function (t, e) {
          return !(this.disabled || !this.bucket || (this.assertBucket(t), this.bucket.toggles[t][e ? "yes" : "no"]++, 0));
        }, t.prototype.assertBucket = function (t) {
          if (this.disabled || !this.bucket) return !1;
          this.bucket.toggles[t] || (this.bucket.toggles[t] = {
            yes: 0,
            no: 0
          });
        }, t.prototype.startTimer = function () {
          var t = this;
          this.timer = setInterval(function () {
            t.sendMetrics();
          }, this.metricsInterval);
        }, t.prototype.bucketIsEmpty = function (t) {
          return 0 === Object.keys(t.bucket.toggles).length;
        }, t.prototype.getPayload = function () {
          var t = r(r({}, this.bucket), {
            stop: new Date()
          });
          return this.bucket = this.createEmptyBucket(), {
            bucket: t,
            appName: this.appName,
            instanceId: "browser"
          };
        }, t;
      }();

      e.default = i;
    },
    475: function _(t, e) {
      "use strict";

      var r = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(t) {
            try {
              c(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              c(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(s, a);
          }

          c((n = n.apply(t, e || [])).next());
        });
      },
          n = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o = function () {
        function t() {
          this.store = new Map();
        }

        return t.prototype.save = function (t, e) {
          return r(this, void 0, void 0, function () {
            return n(this, function (r) {
              return this.store.set(t, e), [2];
            });
          });
        }, t.prototype.get = function (t) {
          return r(this, void 0, void 0, function () {
            return n(this, function (e) {
              return [2, this.store.get(t)];
            });
          });
        }, t;
      }();

      e.default = o;
    },
    432: function _(t, e, r) {
      "use strict";

      var n = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(t) {
            try {
              c(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              c(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(s, a);
          }

          c((n = n.apply(t, e || [])).next());
        });
      },
          o = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var i = r(60),
          s = function () {
        function t() {
          this.prefix = "unleash:repository";
        }

        return t.prototype.save = function (t, e) {
          return n(this, void 0, void 0, function () {
            var r, n, s;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  r = JSON.stringify(e), n = this.prefix + ":" + t, o.label = 1;

                case 1:
                  return o.trys.push([1, 3,, 4]), [4, i.default.setItem(n, r)];

                case 2:
                  return o.sent(), [3, 4];

                case 3:
                  return s = o.sent(), console.error(s), [3, 4];

                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.get = function (t) {
          return n(this, void 0, void 0, function () {
            var e, r, n;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return o.trys.push([0, 2,, 3]), e = this.prefix + ":" + t, [4, i.default.getItem(e)];

                case 1:
                  return [2, (r = o.sent()) ? JSON.parse(r) : void 0];

                case 2:
                  return n = o.sent(), console.error(n), [3, 3];

                case 3:
                  return [2];
              }
            });
          });
        }, t;
      }();

      e.default = s;
    }
  },
      e = {};

  function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = e[n] = {
      exports: {}
    };
    return t[n].call(i.exports, i, i.exports, r), i.exports;
  }

  r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, {
      a: e
    }), e;
  }, r.d = function (t, e) {
    for (var n in e) {
      r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    "use strict";

    r.r(n), r.d(n, {
      FlagProvider: function FlagProvider() {
        return s;
      },
      InMemoryStorageProvider: function InMemoryStorageProvider() {
        return t.InMemoryStorageProvider;
      },
      LocalStorageProvider: function LocalStorageProvider() {
        return t.LocalStorageProvider;
      },
      UnleashClient: function UnleashClient() {
        return t.UnleashClient;
      },
      default: function _default() {
        return f;
      },
      useFlag: function useFlag() {
        return a;
      },
      useFlagsStatus: function useFlagsStatus() {
        return c;
      },
      useUnleashContext: function useUnleashContext() {
        return l;
      },
      useVariant: function useVariant() {
        return u;
      }
    });
    var t = r(9);

    var e = require("react"),
        o = r.n(e)().createContext(null);

    var i = function i(t, e, r) {
      if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) {
        !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
      }
      return t.concat(n || Array.prototype.slice.call(e));
    };

    var s = function s(r) {
      var n = r.config,
          s = r.children,
          a = r.unleashClient,
          c = e.useRef(a);
      n || a || console.warn("You must provide either a config or an unleash client to the flag provider. If you are initializing the client in useEffect, you can avoid this warning by\n      checking if the client exists before rendering."), c.current || (c.current = new t.UnleashClient(n)), e.useEffect(function () {
        c.current.start();
      }, []);

      var u = function u(t) {
        return e = void 0, r = void 0, o = function o() {
          return function (t, e) {
            var r,
                n,
                o,
                i,
                s = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
            return i = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;

            function a(i) {
              return function (a) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; s;) {
                    try {
                      if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                      switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                        case 0:
                        case 1:
                          o = i;
                          break;

                        case 4:
                          return s.label++, {
                            value: i[1],
                            done: !1
                          };

                        case 5:
                          s.label++, n = i[1], i = [0];
                          continue;

                        case 7:
                          i = s.ops.pop(), s.trys.pop();
                          continue;

                        default:
                          if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                            s = 0;
                            continue;
                          }

                          if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                            s.label = i[1];
                            break;
                          }

                          if (6 === i[0] && s.label < o[1]) {
                            s.label = o[1], o = i;
                            break;
                          }

                          if (o && s.label < o[2]) {
                            s.label = o[2], s.ops.push(i);
                            break;
                          }

                          o[2] && s.ops.pop(), s.trys.pop();
                          continue;
                      }

                      i = e.call(t, s);
                    } catch (t) {
                      i = [6, t], n = 0;
                    } finally {
                      r = o = 0;
                    }
                  }

                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, a]);
              };
            }
          }(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, c.current.updateContext(t)];

              case 1:
                return e.sent(), [2];
            }
          });
        }, new ((n = void 0) || (n = Promise))(function (t, i) {
          function s(t) {
            try {
              c(o.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              c(o.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function c(e) {
            var r;
            e.done ? t(e.value) : (r = e.value, r instanceof n ? r : new n(function (t) {
              t(r);
            })).then(s, a);
          }

          c((o = o.apply(e, r || [])).next());
        });
        var e, r, n, o;
      },
          l = function l(t) {
        return c.current.isEnabled(t);
      },
          f = function f(t) {
        return c.current.getVariant(t);
      },
          h = function h(t) {
        for (var e, r = [], n = 1; n < arguments.length; n++) {
          r[n - 1] = arguments[n];
        }

        return (e = c.current).on.apply(e, i([t], r, !1));
      },
          p = e.useMemo(function () {
        return {
          on: h,
          updateContext: u,
          isEnabled: l,
          getVariant: f,
          client: c.current
        };
      }, []);

      return e.createElement(o.Provider, {
        value: p
      }, s);
    },
        a = function a(t) {
      var r = (0, e.useContext)(o),
          n = r.isEnabled,
          i = r.client,
          s = (0, e.useState)(!!n(t)),
          a = s[0],
          c = s[1],
          u = (0, e.useRef)();
      return u.current = a, (0, e.useEffect)(function () {
        i && (i.on("update", function () {
          var e = n(t);
          e !== u.current && (u.current = e, c(!!e));
        }), i.on("ready", function () {
          var e = n(t);
          c(e);
        }));
      }, [i]), a;
    },
        c = function c() {
      var r = (0, e.useContext)(o).on,
          n = (0, e.useState)(!1),
          i = n[0],
          s = n[1],
          a = (0, e.useState)(null),
          c = a[0],
          u = a[1];
      return (0, e.useEffect)(function () {
        r(t.EVENTS.READY, function () {
          s(!0);
        }), r(t.EVENTS.ERROR, function (t) {
          u(t);
        });
      }, []), {
        flagsReady: i,
        flagsError: c
      };
    },
        u = function u(t) {
      var r = (0, e.useContext)(o),
          n = r.getVariant,
          i = r.client,
          s = (0, e.useState)(n(t)),
          a = s[0],
          c = s[1],
          u = (0, e.useRef)();
      return u.current = a, (0, e.useEffect)(function () {
        i && (i.on("update", function () {
          var e = n(t);
          u.current.name === e.name && u.current.enabled === e.enabled || (c(e), u.current = e);
        }), i.on("ready", function () {
          var e = n(t);
          c(e);
        }));
      }, [i]), a || {};
    },
        l = function l() {
      return (0, e.useContext)(o).updateContext;
    },
        f = s;
  })(), module.exports = n;
})();